import React from "react";
import "../css/popupStyle.css";

const Popup = (props) => {
  return (
    <div className="popup">
      <div className="popup_inner" style={props.style}>
        {/* <button
          className="btn btn-primary btn-md btn-blue"
          data-toggle="dropdown"
          onClick={props.closePopup.bind(this, props.IsPopupChecked)}
          style={{
            background: "#505659",
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            lineHeight: "17px",
            textAlign: "center",
            display: "block"
          }}
        >
          <i
            className="fa fa-close"
            aria-hidden="true"
            style={{
              position: "relative",
              left: "-3px",
              top: "-1px"
            }}
          />{" "}
        </button> */}
        <br />
        {props.children}
      </div>
    </div>
  );
};
export default Popup;



// WEBPACK FOOTER //
// ./src/common/popup.js